import React from 'react';

/*
 * The flag mark from the Icelandair tail (the three swooshes cut out of the
 * fin), drawn very large as the startup-loader backdrop. The path is the
 * swoosh subpaths of the tail in src/assets/icelandairLogo.svg, unchanged -
 * only the styling differs (outline + faint fill, .sl-logo-art in
 * startupLoader.css). Decorative, so hidden from assistive tech.
 */

const FLAG = 'M1950,424.6c-5.6,0.7-11.2,1-16.8,0.9 c-8.6-0.1-14-1.2-18.1-2.8c-3.5-1.4-6.6-5.2-5.5-8.1c1-2.2,2.6-4.1,4.8-5.3c10.1-6.5,28.3-9.9,48.4-11.2 C1961,402,1950,424.6,1950,424.6zM2057,372.1c-14.6,17.2-29,18.4-57.4,15.8c-74.6-6.6-89,14-91.4,16.6c0.5-1.9,1.1-3.8,2-5.5 c4.7-10.7,10.4-22.6,16.8-36.8c3.6-7.4,5.6-7.7,8.9-10.1c13.5-8.9,35.2-17.2,64.1-14.7c21.3,1.9,30.6,6.2,43.7,6.9 c5.6,0.4,11.2,0.1,16.7-0.9c14-3,17.6-7.2,17.6-7.2S2068,358,2057,372.1zM2074.1,327c-4.6,2.7-10.6,5.3-22.2,5.7 c-12.8,0.4-20.6-2.4-34.7-4.7c-19.3-3.1-38-4.3-58.2,2.1c-8.6,2.7-16.7,7-23.8,12.6c0,0,14.9-33.5,18.8-42.1 c6.4-13.1,27.7-22.5,55.7-22.2c25.2,0.3,36.5,6.8,57.2,7.1c30.9-0.1,41.1-10.4,41.1-10.4c-1.8,3.8-11.2,23.5-15.6,31.9 C2085.1,318.4,2079.9,323.6,2074.1,327z';

const BlueprintLogo = () => (
  <svg className="sl-logo" viewBox="1904 271 208 158" preserveAspectRatio="xMidYMid meet" aria-hidden="true" focusable="false">
    <path className="sl-logo-art" d={FLAG} />
  </svg>
);

export default BlueprintLogo;
